
import React from "react";
import "./policy.css";

function PrivacyPolicy() {
  return (
    <div className="login-container-main">
      <div className="main-content">
        <h3 className="mb-10">Privacy Policy</h3>
        <div className="">
          <p>Effective Date: 1/11/2024</p>
          <section>
            <h2>Introduction</h2>
            <p>
              This Privacy Policy explains how we collect, use, share, and protect information about both providers
              and customers who use our platform. If you have any questions, please contact us at [email@example.com].
            </p>
          </section>
          <section>
            <h2>Information We Collect</h2>
            <h3>Types of Data</h3>
            <ul>
              <li><strong>Personal Data:</strong> Includes name, address, payment information, etc.</li>
              <li><strong>Usage Data:</strong> Information about your interactions on our platform.</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
